import { useGetCurrentUser } from "@workspace/api-client-react";
import type { Member } from "@workspace/api-client-react";

// WI#23 (coverage-map D4) — someone who captains no squad and isn't an admin gets the runner app
// (Today · My History · My Squad). Captains and admins keep the coach app.
export function useRunnerView(): { isLoading: boolean; isRunnerView: boolean; me: Member | undefined } {
  const { data, isLoading } = useGetCurrentUser();
  const members = data?.members ?? [];
  const isRunnerView = !!data && !data.isAdmin && members.length > 0 && !members.some((m) => m.role === "captain");
  const me = members.find((m) => m.squadId !== null) ?? members[0];
  return { isLoading, isRunnerView, me };
}
